import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa6";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!isVisible) return null;

  return (
    <div
      onClick={scrollToTop}
      className="fixed bottom-5 right-5 z-[300] lg:w-[50px] lg:h-[50px] w-[44px] h-[44px] border-2 border-black hover:shadow-[0_0_0_1px_black] rounded-full bg-[#FEFBF6] flex items-center justify-center cursor-pointer transition-all duration-300 opacity-100"
      title="Scroll to top"
    >
      <FaArrowUp className="text-black text-lg lg:text-xl transition-transform duration-300" />
    </div>
  );
};

export default ScrollToTop;
